export const phone = "028-898585";
export const MAC_KEY = "__MAC_ADDRESS";
export const STATION_KEY = "__STATION_INFO";
